// @core/api/endpoints/legalentity/index.ts
// Auto-generated by corebuilder. DO NOT EDIT.
import { ChangeLegalEntityStatus } from './change_legal_entity_status';
import { CreateLegalEntity } from './create_legal_entity';
import { DeleteLegalEntity } from './delete_legal_entity';
import { GetLegalEntity } from './get_legal_entity';
import { ListLegalEntities } from './list_legal_entities';
import { LookupByIdentifier } from './lookup_by_identifier';
import { SetDefaultLegalEntity } from './set_default_legal_entity';
import { UpdateDefaultSignatory } from './update_default_signatory';
import { UpdateLegalEntity } from './update_legal_entity';
import { VerifyLegalEntity } from './verify_legal_entity';

// Re-export individual endpoints
export {
  ChangeLegalEntityStatus,
  CreateLegalEntity,
  DeleteLegalEntity,
  GetLegalEntity,
  ListLegalEntities,
  LookupByIdentifier,
  SetDefaultLegalEntity,
  UpdateDefaultSignatory,
  UpdateLegalEntity,
  VerifyLegalEntity,
};

// Namespace export for convenient usage
export const legalentityApi = {
  ChangeLegalEntityStatus,
  CreateLegalEntity,
  DeleteLegalEntity,
  GetLegalEntity,
  ListLegalEntities,
  LookupByIdentifier,
  SetDefaultLegalEntity,
  UpdateDefaultSignatory,
  UpdateLegalEntity,
  VerifyLegalEntity,
};
